import { render, staticRenderFns } from "./materialManage.vue?vue&type=template&id=7473fc46&scoped=true"
import script from "./materialManage.vue?vue&type=script&lang=js"
export * from "./materialManage.vue?vue&type=script&lang=js"
import style0 from "./materialManage.vue?vue&type=style&index=0&id=7473fc46&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7473fc46",
  null
  
)

export default component.exports